import { TASK_STATUS } from "./constants/task";
import { flipObject } from "./object";

const taskOrder = [
  TASK_STATUS.SCHEDULED,
  TASK_STATUS.IN_PROGRESS,
  TASK_STATUS.SKIPPED,
  TASK_STATUS.COMPLETED,
  TASK_STATUS.COMPLETED_WITH_ERRORS,
  TASK_STATUS.TIMED_OUT,
  TASK_STATUS.FAILED,
  TASK_STATUS.FAILED_WITH_TERMINAL_ERROR,
];

const arrayAsObject: Record<number, string> = Object.assign({}, taskOrder);

const taskOrderObject = flipObject(arrayAsObject);

export const taskStatusCompareFn = (a: string, b: string) => {
  if (taskOrderObject[a] < taskOrderObject[b]) {
    return -1;
  }
  if (taskOrderObject[a] > taskOrderObject[b]) {
    return 1;
  }
  return 0;
};
